/* =====================================================================
   You Fly LA · "Why Us" pages, Flight Deck B kit (r19, 2026-10-01, theme v57) · assets/yfla-wu.js
   Vanilla JS, no data of its own, no network. Every module reads server-rendered markup by data attribute, so all copy is
   in the HTML (crawlable) and the page still reads without this file. Usage: r19/kit/KIT.md.

   Modules, by attribute (one element may carry several: data-wu="filter acc"):
     data-wu="tabs"      role=tablist/tab/tabpanel, aria-selected, roving tabindex, arrow keys, Home/End
     data-wu="acc"       accordion: [data-wu-item] > button[aria-expanded][aria-controls] + [data-wu-body];
                         data-wu-single = one open at a time; [data-wu-all] = Open All / Close All; #hash deep links
     data-wu="filter"    chip filters with counts ([data-wu-fgroup] > button[data-wu-f]), text search (input[data-wu-q]),
                         items [data-wu-fi data-wu-tags], [data-wu-n] counts, [data-wu-shown], [data-wu-empty], [data-wu-fcap]
     data-wu="stepper"   [data-wu-step] panels, [data-wu-go=i] stops, [data-wu-prev]/[data-wu-next]/[data-wu-play],
                         [data-wu-count], [data-wu-fill], [data-wu-marker]; play stops at the end (data-wu-loop to wrap)
     data-wu="carousel"  [data-wu-track] (native swipe + scroll snap), [data-wu-prev]/[data-wu-next], [data-wu-count]
     data-wu="lb"        photo viewer: button[data-wu-full] (+ data-wu-alt, data-wu-cap); a modal <dialog> built once per page
     data-wu="picker"    [data-wu-pick=name] > button[data-wu-val] (aria-pressed), results [data-wu-result="a|b"] ('*' = any)
     data-wu="ticks"     checklist: button[data-wu-tick] (aria-pressed, optional data-wu-w weight), [data-wu-tick-n],
                         [data-wu-tick-of], [data-wu-tick-fill], [data-wu-tick-msg data-wu-when="none|some|all"]
     data-wu="disclose"  button[data-wu-disclose][aria-controls] toggles the [data-wu-dbody] it controls
   Page-wide (no data-wu needed, anywhere inside .wu):
     [data-wu-live="phones|disc|cons|lessons|tower|rush"]  LIVE status from America/Los_Angeles time
     [data-wu-clock]                                       the current Van Nuys time ("4:12 PM")
     .pill + .wu-end                                       desktop call pill, hidden once the footer curtain opens
   Every module dispatches a bubbling "wu:change" CustomEvent ({ mod, el, value }) after each change, for page scripts.
   Safe to run twice: a second copy of this file only rescans; every element is initialised once (data-wu-on).
   Theme editor: sections reloaded in the editor are rescanned (shopify:section:load).
   ===================================================================== */
(function () {
  'use strict';
  var W = window, d = document, root = d.documentElement;
  if (W.YFLAWU && W.YFLAWU.ready) { W.YFLAWU.scan(d); return; }

  /* ---------- helpers ---------- */
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function q(s, r) { return (r || d).querySelector(s); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }
  function attr(el, k, v) { if (el) el.setAttribute(k, v); }
  function bool(el, k, v) { if (el) el.setAttribute(k, v ? 'true' : 'false'); }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function own(box, list, kind) { /* the elements of list whose nearest module of this kind is box (nested modules stay separate) */
    return list.filter(function (el) {
      var p = el.parentElement;
      while (p && p !== box) { if (p.hasAttribute('data-wu') && (' ' + p.getAttribute('data-wu') + ' ').indexOf(' ' + kind + ' ') >= 0) return false; p = p.parentElement; }
      return true;
    });
  }
  function emit(el, mod, value) {
    var e;
    try { e = new CustomEvent('wu:change', { bubbles: true, detail: { mod: mod, el: el, value: value } }); }
    catch (x) { e = d.createEvent('CustomEvent'); e.initCustomEvent('wu:change', true, false, { mod: mod, el: el, value: value }); }
    el.dispatchEvent(e);
  }
  var APOS = new RegExp('[' + String.fromCharCode(0x2019) + "']", 'g'), MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  function words(s) {
    s = String(s || '').toLowerCase().replace(APOS, '');
    if (s.normalize) s = s.normalize('NFD').replace(MARKS, '');
    return s.replace(/[^a-z0-9$]+/g, ' ').trim().split(' ').filter(Boolean);
  }
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function label(btn, txt) { var l = q('[data-wu-l]', btn); if (l) l.textContent = txt; else btn.textContent = txt; }

  /* ---------- TABS ---------- */
  function tabs(box) {
    var list = own(box, qa('[role="tab"]', box), 'tabs');
    if (!list.length) return;
    function sel(t, focus) {
      list.forEach(function (o) {
        var s = o === t, p = d.getElementById(o.getAttribute('aria-controls'));
        bool(o, 'aria-selected', s); attr(o, 'tabindex', s ? '0' : '-1'); o.classList.toggle('is-on', s);
        if (p) p.classList.toggle('is-on', s);
      });
      if (focus) t.focus();
      emit(box, 'tabs', list.indexOf(t));
    }
    var cur = list.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || list[0];
    sel(cur, false);
    list.forEach(function (t, i) {
      on(t, 'click', function () { sel(t, false); });
      on(t, 'keydown', function (e) {
        var k = e.key, n = list.length, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = n - 1;
        if (j < 0) return;
        e.preventDefault(); sel(list[j], true);
      });
    });
    box.wuSelect = function (i) { if (list[i]) sel(list[i], false); };
  }

  /* ---------- ACCORDION ---------- */
  function acc(box) {
    var items = own(box, qa('[data-wu-item]', box), 'acc');
    var single = box.hasAttribute('data-wu-single');
    var all = qa('[data-wu-all]', box);
    function btnOf(it) { return q('button[aria-controls]', it); }
    function set(it, open) {
      var b = btnOf(it);
      it.classList.toggle('is-open', open); bool(b, 'aria-expanded', open);
    }
    function sync() {
      var vis = items.filter(function (it) { return !it.hidden; });
      var every = vis.length > 0 && vis.every(function (it) { return it.classList.contains('is-open'); });
      all.forEach(function (a) {
        bool(a, 'aria-pressed', every);
        label(a, every ? (a.getAttribute('data-label-close') || 'Close All') : (a.getAttribute('data-label-open') || 'Open All'));
      });
    }
    items.forEach(function (it) {
      var b = btnOf(it);
      if (!b) return;
      set(it, b.getAttribute('aria-expanded') === 'true' || it.classList.contains('is-open'));
      on(b, 'click', function () {
        var open = !it.classList.contains('is-open');
        if (open && single) items.forEach(function (o) { if (o !== it) set(o, false); });
        set(it, open); sync(); emit(box, 'acc', { item: it, open: open });
      });
    });
    all.forEach(function (a) {
      on(a, 'click', function () {
        var open = a.getAttribute('aria-pressed') !== 'true';
        items.forEach(function (it) { if (!it.hidden) set(it, open); });
        sync(); emit(box, 'acc', { all: true, open: open });
      });
    });
    function fromHash() {
      var h = (location.hash || '').slice(1);
      if (!h) return;
      var t; try { t = d.getElementById(decodeURIComponent(h)); } catch (e) { t = null; }
      if (!t || !box.contains(t)) return;
      var it = t.closest('[data-wu-item]');
      if (!it || items.indexOf(it) < 0) return;
      if (single) items.forEach(function (o) { if (o !== it) set(o, false); });
      set(it, true); sync();
      W.setTimeout(function () { it.scrollIntoView({ block: 'start', behavior: RM.matches ? 'auto' : 'smooth' }); }, 60);
    }
    on(W, 'hashchange', fromHash);
    fromHash(); sync();
    box.wuOpen = function (it, open) { set(it, open); sync(); };
    box.wuSync = sync;
  }

  /* ---------- FILTER: chips with counts + text search ---------- */
  function filter(box) {
    var groups = own(box, qa('[data-wu-fgroup]', box), 'filter');
    if (!groups.length && q('[data-wu-f]', box)) groups = [box];
    var items = own(box, qa('[data-wu-fi]', box), 'filter');
    var input = own(box, qa('input[data-wu-q]', box), 'filter')[0] || null;
    var clear = own(box, qa('[data-wu-qx]', box), 'filter');
    var shown = own(box, qa('[data-wu-shown]', box), 'filter');
    var empty = own(box, qa('[data-wu-empty]', box), 'filter');
    var caps = own(box, qa('[data-wu-fcap]', box), 'filter');
    var auto = parseInt(box.getAttribute('data-wu-autoopen'), 10) || 0;
    var total = items.length;
    var hay = items.map(function (it) {
      var t = (it.getAttribute('data-wu-text') || it.textContent) + ' ' + (it.getAttribute('data-wu-tags') || '');
      return words(t);
    });
    var tags = items.map(function (it) { return ' ' + (it.getAttribute('data-wu-tags') || '') + ' '; });
    var chipsBy = groups.map(function (g) { return qa('[data-wu-f]', g); });
    var state = chipsBy.map(function (cs) {
      var on1 = cs.filter(function (c) { return c.getAttribute('aria-pressed') === 'true' || c.classList.contains('is-on'); })[0];
      return on1 ? on1.getAttribute('data-wu-f') : 'all';
    });
    function hitQ(i, qw) {
      for (var a = 0; a < qw.length; a++) {
        var ok = false;
        for (var b = 0; b < hay[i].length; b++) { if (hay[i][b].indexOf(qw[a]) === 0) { ok = true; break; } }
        if (!ok) return false;
      }
      return true;
    }
    function match(i, st, qw) {
      for (var g = 0; g < st.length; g++) { if (st[g] !== 'all' && tags[i].indexOf(' ' + st[g] + ' ') < 0) return false; }
      return !qw.length || hitQ(i, qw);
    }
    function run(user) {
      var qw = input ? words(input.value) : [];
      var n = 0, hits = [];
      items.forEach(function (it, i) { var ok = match(i, state, qw); it.hidden = !ok; if (ok) { n++; hits.push(it); } });
      chipsBy.forEach(function (cs, g) {
        cs.forEach(function (c) {
          var v = c.getAttribute('data-wu-f'), s = v === state[g];
          c.classList.toggle('is-on', s); bool(c, 'aria-pressed', s);
          var alt = state.slice(); alt[g] = v;
          var cnt = 0; items.forEach(function (it, i) { if (match(i, alt, qw)) cnt++; });
          var ne = q('[data-wu-n]', c); if (ne) ne.textContent = cnt;
          c.disabled = cnt === 0 && !s;
        });
      });
      var filtered = qw.length > 0 || state.some(function (v) { return v !== 'all'; });
      box.classList.toggle('is-filtered', filtered);
      shown.forEach(function (el) {
        var tpl = n === total ? (el.getAttribute('data-wu-tpl-all') || el.getAttribute('data-wu-tpl') || '{n} of {total}') : (n === 0 && el.getAttribute('data-wu-tpl-none') ? el.getAttribute('data-wu-tpl-none') : (el.getAttribute('data-wu-tpl') || '{n} of {total}'));
        el.textContent = tpl.replace('{n}', n).replace('{total}', total).replace('{q}', input ? input.value.trim() : '');
      });
      empty.forEach(function (el) { el.hidden = n > 0; });
      caps.forEach(function (el) {
        var v = el.getAttribute('data-wu-fcap'), show = false;
        if (v === 'all') show = state.every(function (s) { return s === 'all'; });
        else show = state.indexOf(v) >= 0;
        el.hidden = !show;
      });
      clear.forEach(function (c) { c.hidden = !(input && input.value); });
      var accBox = (' ' + (box.getAttribute('data-wu') || '') + ' ').indexOf(' acc ') >= 0 ? box : (q('[data-wu~="acc"]', box) || box.closest('[data-wu~="acc"]'));
      if (user && auto && qw.length && accBox && accBox.wuOpen) {
        if (hits.length > 0 && hits.length <= auto) hits.forEach(function (it) { if (it.hasAttribute('data-wu-item')) accBox.wuOpen(it, true); });
      }
      if (accBox && accBox.wuSync) accBox.wuSync();
      if (user) emit(box, 'filter', { state: state.slice(), q: input ? input.value : '', shown: n });
    }
    chipsBy.forEach(function (cs, g) {
      cs.forEach(function (c) { on(c, 'click', function () { state[g] = c.getAttribute('data-wu-f'); run(true); }); });
    });
    if (input) {
      var t = 0;
      on(input, 'input', function () { W.clearTimeout(t); t = W.setTimeout(function () { run(true); }, 120); });
      on(input, 'keydown', function (e) { if (e.key === 'Escape' && input.value) { input.value = ''; run(true); } });
      var form = input.closest('form'); if (form) on(form, 'submit', function (e) { e.preventDefault(); run(true); });
    }
    clear.forEach(function (c) { on(c, 'click', function () { if (input) { input.value = ''; input.focus(); } run(true); }); });
    run(false);
    box.wuFilter = function (g, v) { state[g || 0] = v; run(true); };
  }

  /* ---------- STEPPER (prev / next / play) ---------- */
  function stepper(box) {
    var steps = own(box, qa('[data-wu-step]', box), 'stepper');
    var n = steps.length;
    if (!n) return;
    var gos = own(box, qa('[data-wu-go]', box), 'stepper'), prevs = own(box, qa('[data-wu-prev]', box), 'stepper'), nexts = own(box, qa('[data-wu-next]', box), 'stepper');
    var plays = own(box, qa('[data-wu-play]', box), 'stepper'), counts = own(box, qa('[data-wu-count]', box), 'stepper'), totals = own(box, qa('[data-wu-total]', box), 'stepper');
    var fills = own(box, qa('[data-wu-fill]', box), 'stepper'), marks = own(box, qa('[data-wu-marker]', box), 'stepper');
    var loop = box.hasAttribute('data-wu-loop'), ms = parseInt(box.getAttribute('data-wu-interval'), 10) || 2600;
    var cur = 0, timer = 0;
    steps.forEach(function (s, i) { if (s.classList.contains('is-on')) cur = i; });
    if (box.hasAttribute('data-wu-start')) cur = Math.max(0, Math.min(n - 1, parseInt(box.getAttribute('data-wu-start'), 10) || 0));
    function go(i, why) {
      cur = Math.max(0, Math.min(n - 1, i));
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.classList.toggle('is-past', k < cur); });
      gos.forEach(function (b) {
        var k = parseInt(b.getAttribute('data-wu-go'), 10), host = b.parentElement && b.parentElement.tagName === 'LI' ? b.parentElement : null;
        b.classList.toggle('is-on', k === cur); b.classList.toggle('is-past', k < cur);
        if (host) { host.classList.toggle('is-on', k === cur); host.classList.toggle('is-past', k < cur); }
        if (b.hasAttribute('aria-pressed')) bool(b, 'aria-pressed', k === cur);
        if (k === cur) attr(b, 'aria-current', 'step'); else b.removeAttribute('aria-current');
      });
      prevs.forEach(function (b) { b.disabled = !loop && cur === 0; });
      nexts.forEach(function (b) { b.disabled = !loop && cur === n - 1; });
      counts.forEach(function (c) { c.textContent = pad2(cur + 1); });
      var p = n > 1 ? cur / (n - 1) : 0;
      box.style.setProperty('--wu-step', cur); box.style.setProperty('--wu-steps', n); box.style.setProperty('--wu-prog', p.toFixed(4));
      fills.forEach(function (f) { f.style.width = (p * 100).toFixed(2) + '%'; });
      marks.forEach(function (m) { m.style.left = 'calc(24px + (100% - 48px) * ' + ((2 * cur + 1) / (2 * n)).toFixed(4) + ')'; });
      plays.forEach(function (b) {
        var playing = !!timer;
        bool(b, 'aria-pressed', playing);
        label(b, playing ? (b.getAttribute('data-label-pause') || 'Pause') : (cur === n - 1 ? (b.getAttribute('data-label-replay') || b.getAttribute('data-label-play') || 'Play') : (b.getAttribute('data-label-play') || 'Play')));
      });
      emit(box, 'stepper', { index: cur, why: why || '' });
    }
    function stop() { if (timer) { W.clearInterval(timer); timer = 0; } }
    function play() {
      if (timer) { stop(); go(cur, 'pause'); return; }
      if (cur === n - 1) cur = 0;
      timer = W.setInterval(function () {
        if (cur >= n - 1) { if (loop) { go(0, 'play'); return; } stop(); go(cur, 'end'); return; }
        go(cur + 1, 'play');
      }, RM.matches ? Math.max(ms, 4000) : ms);
      go(cur, 'play');
    }
    totals.forEach(function (t) { t.textContent = pad2(n); });
    gos.forEach(function (b) {
      on(b, 'click', function () { stop(); go(parseInt(b.getAttribute('data-wu-go'), 10), 'go'); });
      on(b, 'keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = cur + 1; else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = cur - 1; else return;
        e.preventDefault(); stop(); go(j, 'key');
        var t = gos.filter(function (x) { return parseInt(x.getAttribute('data-wu-go'), 10) === cur; })[0]; if (t) t.focus();
      });
    });
    prevs.forEach(function (b) { on(b, 'click', function () { stop(); go(loop && cur === 0 ? n - 1 : cur - 1, 'prev'); }); });
    nexts.forEach(function (b) { on(b, 'click', function () { stop(); go(loop && cur === n - 1 ? 0 : cur + 1, 'next'); }); });
    plays.forEach(function (b) { if (!b.hasAttribute('aria-pressed')) attr(b, 'aria-pressed', 'false'); on(b, 'click', play); });
    on(d, 'visibilitychange', function () { if (d.hidden && timer) { stop(); go(cur, 'pause'); } });
    go(cur, 'init');
    box.wuGo = function (i) { stop(); go(i, 'api'); };
  }

  /* ---------- CAROUSEL (buttons + native swipe) ---------- */
  function carousel(box) {
    var track = own(box, qa('[data-wu-track]', box), 'carousel')[0];
    if (!track) return;
    var prevs = own(box, qa('[data-wu-prev]', box), 'carousel'), nexts = own(box, qa('[data-wu-next]', box), 'carousel'), counts = own(box, qa('[data-wu-count]', box), 'carousel');
    function slides() { return Array.prototype.slice.call(track.children).filter(function (s) { return !s.hidden && s.offsetParent !== null; }); }
    function idx() {
      var s = slides(), tl = track.getBoundingClientRect().left, best = 0, bd = 1e9;
      s.forEach(function (el, i) { var dx = Math.abs(el.getBoundingClientRect().left - tl); if (dx < bd) { bd = dx; best = i; } });
      return best;
    }
    function upd() {
      var s = slides(), i = idx(), max = track.scrollWidth - track.clientWidth - 2;
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
      counts.forEach(function (c) { c.textContent = pad2(Math.min(s.length, i + 1)) + ' / ' + pad2(s.length); });
    }
    function to(i) {
      var s = slides(); if (!s.length) return;
      i = Math.max(0, Math.min(s.length - 1, i));
      track.scrollTo({ left: s[i].offsetLeft - track.firstElementChild.offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
      emit(box, 'carousel', i);
    }
    prevs.forEach(function (b) { on(b, 'click', function () { to(idx() - 1); }); });
    nexts.forEach(function (b) { on(b, 'click', function () { to(idx() + 1); }); });
    var t = 0;
    on(track, 'scroll', function () { W.clearTimeout(t); t = W.setTimeout(upd, 80); }, { passive: true });
    on(W, 'resize', upd);
    if (!track.hasAttribute('tabindex')) attr(track, 'tabindex', '0');
    on(box, 'wu:change', function (e) { if (e.detail && e.detail.mod === 'filter') { track.scrollLeft = 0; W.setTimeout(upd, 30); } });
    upd();
    box.wuTo = to;
  }

  /* ---------- PHOTO VIEWER (modal dialog: focus kept inside, Esc closes, focus returns) ---------- */
  var LB = null;
  function lbDialog(scope) {
    if (LB) return LB;
    var host = (scope && scope.closest('.wu')) || q('.wu') || d.body;
    var dlg = d.createElement('dialog');
    dlg.className = 'lb'; attr(dlg, 'aria-label', 'Photo viewer');
    var svg = function (p) { return '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><path d="' + p + '"></path></svg>'; };
    dlg.innerHTML = '<div class="lb-top"><p class="lb-count" aria-live="polite"><span data-lb="n">1</span> / <span data-lb="of">1</span></p>' +
      '<button type="button" class="icon-btn" data-lb="close" aria-label="Close photo viewer">' + svg('M6 6l12 12M18 6L6 18') + '</button></div>' +
      '<div class="lb-stage"><button type="button" class="icon-btn lb-nav" data-lb="prev" aria-label="Previous photo">' + svg('M15 6l-6 6 6 6') + '</button>' +
      '<figure class="lb-fig"><img data-lb="img" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt=""><figcaption data-lb="cap"></figcaption></figure>' +
      '<button type="button" class="icon-btn lb-nav" data-lb="next" aria-label="Next photo">' + svg('M9 6l6 6-6 6') + '</button></div>';
    host.appendChild(dlg);
    var img = q('[data-lb="img"]', dlg), cap = q('[data-lb="cap"]', dlg), nEl = q('[data-lb="n"]', dlg), ofEl = q('[data-lb="of"]', dlg);
    var st = { list: [], cur: 0, opener: null };
    function show(i) {
      var L = st.list; if (!L.length) return;
      st.cur = (i + L.length) % L.length;
      var b = L[st.cur];
      img.removeAttribute('srcset'); img.src = b.getAttribute('data-wu-full'); img.alt = b.getAttribute('data-wu-alt') || '';
      cap.textContent = b.getAttribute('data-wu-cap') || ''; nEl.textContent = st.cur + 1; ofEl.textContent = L.length;
      var many = L.length > 1; qa('.lb-nav', dlg).forEach(function (x) { x.hidden = !many; });
    }
    function close() {
      if (dlg.open) dlg.close();
      root.classList.remove('wu-lb-open');
      if (st.opener) { try { st.opener.focus(); } catch (e) {} }
    }
    on(q('[data-lb="close"]', dlg), 'click', close);
    on(q('[data-lb="prev"]', dlg), 'click', function () { show(st.cur - 1); });
    on(q('[data-lb="next"]', dlg), 'click', function () { show(st.cur + 1); });
    on(dlg, 'cancel', function (e) { e.preventDefault(); close(); });
    on(dlg, 'click', function (e) { if (e.target === dlg) close(); });
    on(dlg, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(st.cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(st.cur + 1); }
      else if (e.key === 'Tab') {
        var f = qa('button', dlg).filter(function (x) { return !x.hidden; }), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    LB = {
      open: function (list, i, opener) {
        st.list = list; st.opener = opener; show(i);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else attr(dlg, 'open', '');
        root.classList.add('wu-lb-open');
        q('[data-lb="close"]', dlg).focus();
      }
    };
    return LB;
  }
  function lb(box) {
    var btns = own(box, qa('[data-wu-full]', box), 'lb');
    btns.forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        var vis = btns.filter(function (x) { return x.offsetParent !== null && !x.closest('[hidden]'); });
        lbDialog(box).open(vis, Math.max(0, vis.indexOf(b)), b);
        emit(box, 'lb', b);
      });
    });
  }

  /* ---------- PICKER: choose A (+ B) -> the matching server-rendered result ---------- */
  function picker(box) {
    var groups = own(box, qa('[data-wu-pick]', box), 'picker');
    var results = own(box, qa('[data-wu-result]', box), 'picker');
    if (!groups.length || !results.length) return;
    var vals = groups.map(function (g) {
      var bs = qa('[data-wu-val]', g), s = bs.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || bs[0];
      return s ? s.getAttribute('data-wu-val') : '';
    });
    function fits(key) {
      var k = key.split('|');
      for (var i = 0; i < vals.length; i++) { var x = k[i] === undefined ? '*' : k[i]; if (x !== '*' && x !== vals[i]) return false; }
      return true;
    }
    function run(user) {
      groups.forEach(function (g, i) { qa('[data-wu-val]', g).forEach(function (b) { var s = b.getAttribute('data-wu-val') === vals[i]; bool(b, 'aria-pressed', s); b.classList.toggle('is-on', s); }); });
      var hit = results.filter(function (r) { return fits(r.getAttribute('data-wu-result')); })[0] || null;
      results.forEach(function (r) { r.classList.toggle('is-on', r === hit); });
      box.setAttribute('data-wu-picked', vals.join('|'));
      if (user) emit(box, 'picker', { values: vals.slice(), result: hit });
    }
    groups.forEach(function (g, i) {
      qa('[data-wu-val]', g).forEach(function (b) { on(b, 'click', function () { vals[i] = b.getAttribute('data-wu-val'); run(true); }); });
    });
    run(false);
  }

  /* ---------- TICKS: a checklist with a count, a meter and a message ---------- */
  function ticks(box) {
    var bs = own(box, qa('[data-wu-tick]', box), 'ticks');
    if (!bs.length) return;
    var ns = own(box, qa('[data-wu-tick-n]', box), 'ticks'), ofs = own(box, qa('[data-wu-tick-of]', box), 'ticks'), fills = own(box, qa('[data-wu-tick-fill]', box), 'ticks'), msgs = own(box, qa('[data-wu-tick-msg]', box), 'ticks');
    function w(b) { return parseFloat(b.getAttribute('data-wu-w')) || 1; }
    var max = bs.reduce(function (s, b) { return s + w(b); }, 0);
    function run(user) {
      var got = bs.reduce(function (s, b) { return s + (b.getAttribute('aria-pressed') === 'true' ? w(b) : 0); }, 0);
      var st = got <= 0 ? 'none' : (got >= max ? 'all' : 'some');
      box.classList.remove('is-none', 'is-some', 'is-all'); box.classList.add('is-' + st);
      ns.forEach(function (e) { e.textContent = Math.round(got); });
      ofs.forEach(function (e) { e.textContent = Math.round(max); });
      fills.forEach(function (e) { e.style.width = (max ? got / max * 100 : 0).toFixed(1) + '%'; });
      msgs.forEach(function (m) { m.hidden = (m.getAttribute('data-wu-when') || 'some') !== st; });
      box.style.setProperty('--wu-tick', (max ? got / max : 0).toFixed(3));
      if (user) emit(box, 'ticks', { got: got, max: max, state: st });
    }
    bs.forEach(function (b) {
      if (!b.hasAttribute('aria-pressed')) attr(b, 'aria-pressed', 'false');
      on(b, 'click', function () { bool(b, 'aria-pressed', b.getAttribute('aria-pressed') !== 'true'); b.classList.toggle('is-on', b.getAttribute('aria-pressed') === 'true'); run(true); });
    });
    run(false);
  }

  /* ---------- DISCLOSE: one button shows / hides one block ---------- */
  function disclose(box) {
    own(box, qa('[data-wu-disclose]', box), 'disclose').forEach(function (b) {
      var t = d.getElementById(b.getAttribute('aria-controls'));
      if (!t) return;
      function set(open) {
        bool(b, 'aria-expanded', open); t.classList.toggle('is-open', open);
        var l = open ? b.getAttribute('data-label-close') : b.getAttribute('data-label-open');
        if (l) label(b, l);
      }
      set(b.getAttribute('aria-expanded') === 'true');
      on(b, 'click', function () { var o = b.getAttribute('aria-expanded') !== 'true'; set(o); emit(box, 'disclose', { el: t, open: o }); });
    });
  }

  /* ---------- LIVE status (America/Los_Angeles) ---------- */
  var WDL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var WDS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  function laNow(ms) {
    var t = new Date(ms || Date.now()), h, m, wd;
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23' }).formatToParts(t);
      parts.forEach(function (p) {
        if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
        else if (p.type === 'minute') m = parseInt(p.value, 10);
        else if (p.type === 'weekday') wd = WDS[p.value];
      });
      if (isNaN(h) || isNaN(m) || wd === undefined) throw new Error('parts');
    } catch (e) {
      /* fallback: US Pacific rules (PDT from the 2nd Sunday of March 2:00 to the 1st Sunday of November 2:00) */
      var y = t.getUTCFullYear();
      var mar = new Date(Date.UTC(y, 2, 1)), nov = new Date(Date.UTC(y, 10, 1));
      var dst0 = Date.UTC(y, 2, 1 + ((7 - mar.getUTCDay()) % 7) + 7, 10), dst1 = Date.UTC(y, 10, 1 + ((7 - nov.getUTCDay()) % 7), 9);
      var off = (t.getTime() >= dst0 && t.getTime() < dst1) ? 7 : 8;
      var u = new Date(t.getTime() - off * 3600000);
      h = u.getUTCHours(); m = u.getUTCMinutes(); wd = u.getUTCDay();
    }
    return { h: h, m: m, mins: h * 60 + m, wd: wd, day: WDL[wd], weekday: wd >= 1 && wd <= 5, label: (((h + 11) % 12) + 1) + ':' + pad2(m) + (h < 12 ? ' AM' : ' PM') };
  }
  /* from / to in minutes after midnight; days 0 = Sunday. Text: open / before (earlier today) / after (later today). */
  var SCHED = {
    phones: { from: 540, to: 1260, open: 'Phones Open Now · Until 9 PM', before: 'Phones Open At 9 AM', after: 'Phones Open At 9 AM Tomorrow' },
    lessons: { from: 540, to: 1260, open: 'Lessons Running Now · Until 9 PM', before: 'Lessons From 9 AM Today', after: 'Lessons From 9 AM Tomorrow' },
    disc: { from: 600, to: 1140, open: 'Discovery Flights Flying Now · Until 7 PM', before: 'Discovery Flights Today 10 AM–7 PM', after: 'Discovery Flights Tomorrow 10 AM–7 PM' },
    cons: { from: 600, to: 1140, open: 'Consultations Today Until 7 PM', before: 'Consultations Today 10 AM–7 PM', after: 'Consultations Tomorrow 10 AM–7 PM' },
    tower: { from: 360, to: 1365, open: 'Tower Open · Until 10:45 PM', before: 'Tower Opens 6:00 AM', after: 'Tower Opens 6:00 AM' },
    rush: { from: 960, to: 1140, days: [1, 2, 3, 4, 5], open: 'Rush Hour Right Now: Leave Earlier Than The Map Says', before: 'Weekdays 4–7 PM, Allow Extra Time', after: 'Weekdays 4–7 PM, Allow Extra Time' }
  };
  function hm(s) { var p = String(s || '').split(':'); return parseInt(p[0], 10) * 60 + (parseInt(p[1], 10) || 0); }
  function liveOne(el, t) {
    var k = el.getAttribute('data-wu-live'), S = SCHED[k] || {};
    var from = el.hasAttribute('data-from') ? hm(el.getAttribute('data-from')) : S.from;
    var to = el.hasAttribute('data-to') ? hm(el.getAttribute('data-to')) : S.to;
    if (from === undefined || to === undefined || isNaN(from) || isNaN(to)) return;
    var days = S.days || null;
    if (el.hasAttribute('data-days')) { var r = el.getAttribute('data-days').split('-'); days = []; for (var i = +r[0]; i <= +(r[1] || r[0]); i++) days.push(i); }
    var today = !days || days.indexOf(t.wd) >= 0;
    var st = today && t.mins >= from && t.mins < to ? 'open' : (today && t.mins < from ? 'before' : 'after');
    var txt = el.getAttribute('data-' + st) || (st !== 'open' ? el.getAttribute('data-closed') : null) || S[st] || '';
    txt = txt.split('{time}').join(t.label).split('{day}').join(t.day);
    var slot = q('[data-wu-live-t]', el) || (el.children.length ? null : el);
    if (slot && txt) slot.textContent = txt;
    el.setAttribute('data-state', st);
    el.classList.toggle('is-open', st === 'open'); el.classList.toggle('is-closed', st !== 'open');
  }
  var liveT = 0;
  function liveAll() {
    var t = laNow(), els = qa('.wu [data-wu-live]');
    els.forEach(function (el) { liveOne(el, t); });
    qa('.wu [data-wu-clock]').forEach(function (el) { el.textContent = t.label; });
    return els.length + qa('.wu [data-wu-clock]').length;
  }
  function liveStart() {
    if (!liveAll() || liveT) return;
    liveT = W.setInterval(function () { if (!d.hidden) liveAll(); }, 30000);
    on(d, 'visibilitychange', function () { if (!d.hidden) liveAll(); });
  }

  /* ---------- desktop call pill: off once the footer curtain starts to open ---------- */
  function pill(wu) {
    var p = q('.pill', wu), end = q('.wu-end', wu);
    if (!p || !end || p.__wuPill || !('IntersectionObserver' in W)) return;
    p.__wuPill = 1;
    new IntersectionObserver(function (es) { es.forEach(function (e) { p.classList.toggle('is-off', e.isIntersecting || e.boundingClientRect.top < 0); }); }, { rootMargin: '0px 0px 40px 0px' }).observe(end);
  }

  /* ---------- boot ---------- */
  var MODS = { tabs: tabs, acc: acc, filter: filter, stepper: stepper, carousel: carousel, lb: lb, picker: picker, ticks: ticks, disclose: disclose };
  var ORDER = ['tabs', 'acc', 'filter', 'stepper', 'carousel', 'lb', 'picker', 'ticks', 'disclose'];
  function scan(scope) {
    scope = scope || d;
    var els = qa('[data-wu]', scope);
    if (scope.nodeType === 1 && scope.hasAttribute('data-wu')) els.unshift(scope);
    ORDER.forEach(function (k) {
      els.forEach(function (el) {
        var kinds = (' ' + el.getAttribute('data-wu') + ' ');
        if (kinds.indexOf(' ' + k + ' ') < 0) return;
        var mark = 'data-wu-on-' + k;
        if (el.hasAttribute(mark)) return;
        el.setAttribute(mark, '1');
        try { MODS[k](el); } catch (e) { if (W.console) console.warn('yfla-wu ' + k, e); }
      });
    });
    qa('.wu').forEach(pill);
    liveStart();
  }
  W.YFLAWU = { ready: true, v: '1.0', scan: scan, laNow: laNow, sched: SCHED, live: liveAll, emit: emit };
  root.classList.add('wu-js');
  function start() { scan(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();